import { isAutomationBrowser } from './isAutomationBrowser';

export function phiTrack(eventName, props) {
  try {
    if (isAutomationBrowser()) return;
    if (typeof window !== 'undefined' && window.phi && typeof window.phi.track === 'function') {
      window.phi.track(eventName, props || {});
    }
  } catch {
    // ignore
  }
}
